import script from "./ShopWhereToBuy.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopWhereToBuy.vue?vue&type=script&setup=true&lang=js"

import "./ShopWhereToBuy.vue?vue&type=style&index=0&id=71dc6bc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71dc6bc3"]])

export default __exports__